
const qa = [
  {q:"¿Cómo se llega a la cabaña?", a:"Santa María está ubicado en el km 185 en dirección hacia el norte. La cabaña Pérgola del Sol, está ubicado en la calle Uno Norte, Parcela 24, a punto de llegar al final de la calle. Puede consultar el mapa para llegar"},
  {q:"¿Cuánto se cobra por noche?", a:"El precio es de $516,686 CLP por 5 noches."},
  {q:"¿Se puede llevar mascota?", a:"Sí, se puede llevar su mascota, contamos con caníl."},
  {q:"¿Existe comercio cercano?", a:"Sí, donde se venden los productos escenciales y vecinos que hacen pan amasado todos los días."},
  {q:"¿Cómo llegar a la playa?", a:"El borde del mar está a 30 minutos caminando y a 5 minutos en auto."}
];
export default function Faq(){
  return (
    <section id="faq" className="py-16 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-center">Preguntas Frecuentes</h2>
        <div className="mt-8 space-y-3">
          {qa.map((i)=>(
            <details key={i.q} className="p-4 bg-white rounded-xl border">
              <summary className="cursor-pointer font-medium">{i.q}</summary>
              <p className="mt-2 text-gray-600">{i.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

